<template>
  <div>
    <!-- FBA操作选择 -->
    <el-dialog :title="$t('message.fBAOperationWorkloadStatus')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="600px" center>
      <div class="content">
        <el-table :data="tableData" :header-cell-style="{ background: '#EDEFF4' }" max-height="750px">
          <!-- FBA操作 -->
          <el-table-column :label="$t('message.fBAOperation')" align="center" prop="realname"></el-table-column>
          <!--未贴完配送单数  -->
          <el-table-column :label="$t('message.unpastedDeliverySingular')" align="center"
            prop="porderCount"></el-table-column>
          <!-- 未贴完标数 -->
          <el-table-column :label="$t('message.numberOfUnpastedLabels')" align="center" prop="tagSum"></el-table-column>
          <!-- 最早操作时间 -->
          <el-table-column :label="$t('message.earliestOperationTime')" align="center" prop="datetime_translate"
            width="150"></el-table-column>

        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {

  data() {
    return {
      dialogVisible: false,
      tableData: []
    };
  },
  // created() {
  //   this.fbaInfo()
  // },
  methods: {
    //下属人员列表
    fbaInfo() {
      this.$api.porderApi.fbaInfo().then(res => {
        this.tableData = res.data
      })
    },


  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == true) {
        this.fbaInfo();
      }
    },
  },
}
</script>
<style lang='scss' scoped>
.content {
  padding: 0 20px;
}
</style>